/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-29 10:05:09
 * @LastEditors: yd
 * @LastEditTime: 2020-10-21 10:38:55
 */
import http from '../httpConfig'
const table = 'mrbase_sys_apply_on_behalf'
//业务申请代理

//业务申请代理列表
export const getBusinessApplyList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/operation_replace/list-replace/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//员业务申请代理新增接口
export const addBusinessApply = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/operation_replace/add-replace/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//员业务申请代理修改接口
export const updateBusinessApply = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/operation_replace/update-replace/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//员业务申请代理删除接口
export const deleteBusinessApply = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/operation_replace/delete-replace/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//员业务申请代理详情
export const detailBusinessApply = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/operation_replace/find-replace/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}